import axios from "axios";
import {clearTokens, getToken, setTokens} from "./tokenManager";
import {apiUrls} from "../constants/apiUrls";
import {ROUTES} from "../constants/routes";

let isRefreshing = false;
let failedQueue: any[] = [];

const processQueue = (error: any, token: string | null = null) => {
    failedQueue.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });

    failedQueue = [];
};

const axiosInstance = axios.create();
axiosInstance.defaults.withCredentials = true;

axiosInstance.interceptors.request.use(   (config) => {
    const token = getToken();
    if (token)
        config.headers.Authorization = `Bearer ${token}`;

    if (!(config.data instanceof FormData)){
        config.headers['Content-Type'] = 'application/json';
    }

    return config;
}, async (error) => {
    return Promise.reject(error);
} );

axiosInstance.interceptors.response.use( (response) => {
    return response;
}, async (error) => {

    const originalRequest = error.config;

    if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
            return new Promise(function (resolve, reject) {
                failedQueue.push({resolve, reject});
            })
                .then((token) => {
                    originalRequest.headers.Authorization = `Bearer ${token}`;
                    return axiosInstance(originalRequest);
                })
                .catch((err) => Promise.reject(err));
        }


        originalRequest._retry = true;
        isRefreshing = true;
        try {
            const res = await axiosInstance.post(apiUrls.authorization.refreshToken)
            const newAccessToken = res.data.accessToken;
            setTokens(newAccessToken);

            processQueue(null, newAccessToken);

            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;

            return axiosInstance(originalRequest);

        } catch (err) {
            console.log("Токен истек, очищаем...")
            processQueue(err, null);
            clearTokens();
            window.location.href = ROUTES.LOGIN.path;
            return Promise.reject(err);

        } finally {
            isRefreshing = false;
        }
    }
    return Promise.reject(error);
});

export default axiosInstance;